class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if(cartLink != null ){
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
       cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
    
   
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    document.querySelector('.cart-drawer').classList.add('js-added-class');
    if (document.querySelector('.js-added-class') !== null ) {
      var elems = document.querySelectorAll(".animate--slide-in");
      if (elems.length > 0) {
          [].forEach.call(elems, function(el) {
              el.classList.remove("animate--slide-in");
          });
      }
    }
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    var popup_content = document.querySelectorAll('.jquery-modal');
    popup_content.forEach((element) => {
      element.classList.remove('open');
    });
    document.body.classList.add('overflow-hidden');
    // upsell slider
     var mySwiper = new Swiper('.upsell-items-slider', {
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      }, slidesPerView: 'auto',
      freeMode: false,
      slidesPerGroup: 2,
      spaceBetween: 0,
      centerInsufficientSlides:true,
      loop: false,
    });
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      if(cart.item_count >= 0){
        document.querySelector(".cart-count-bubble span").innerHTML = cart.item_count;
      }
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class UpsellAddToCart extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  bindEvents() {
    this.querySelectorAll('.upsellAddicon').forEach((upsellBtn) =>
      upsellBtn.addEventListener('click', this.onClickAtcUpsell.bind(this))
    );
  }
  
  freeAddToCart(formData){
    fetch('/cart/add.js', {
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
    }).then(function(response) {
      return response.json();
    }).then(function(json) {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer','.cart-progressbar'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
                  
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      // upsell slider
      setTimeout(function(){
          var mySwiper = new Swiper('.upsell-items-slider', {
              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
              }, slidesPerView: 'auto',
              freeMode: false,
              slidesPerGroup: 2,
              spaceBetween: 0,
              centerInsufficientSlides:true,
              loop: false,
            })
      },1000);
    }).catch(function(err) {
      console.error(err)
    });
  }
  
  onClickAtcUpsell(event) {
    var main__this = this;
    event.preventDefault();
    var __this = event.currentTarget;
    var variant_id = __this.getAttribute('data-variant-id');
      var addData = {
        'id':variant_id,
        'quantity':1
      };
      fetch('/cart/add.js', {
        body: JSON.stringify(addData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer','.cart-progressbar'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
                    
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          // upsell slider
          var mySwiper = new Swiper('.upsell-items-slider', {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }, slidesPerView: 'auto',
            freeMode: false,
            slidesPerGroup: 2,
            spaceBetween: 0,
            centerInsufficientSlides:true,
            loop: false,
          })
        })
        .catch((e) => {
          console.error(e);
        });
        
          let free_product_price = document.getElementById("cart-progresbar").getAttribute('data-limit-amount');
          let mystery_gift_card = document.getElementById("cart-progresbar").getAttribute('data-mystery-amount');
        
          fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            
            let variantId = document.querySelector('.gift-cart-image').getAttribute('data-gift-cart');
            let variantId2 = document.querySelector('.mystery-gift-card').getAttribute('data-gift-cart');
            let variant_id_str = variantId.toString();
            let variant_id_str2 = variantId2.toString()
            let available = false;
            let second_available = false;
              for (var i = 0; i < cart.items.length; i++) {
                if(cart.items[i].id == variant_id_str ){
                  available = true;
                }else if(cart.items[i].id == variant_id_str2 ){
                  second_available = true;
                }
              }
            if(cart.total_price > mystery_gift_card ){
              if(available == false && second_available == false){
                  let formData = {
                    'items': [{
                        'id': variant_id_str,
                        'quantity': 1
                        },{
                        'id': variant_id_str2,
                        'quantity': 1
                        }]
                  };
                main__this.freeAddToCart(formData);
              }else if(available == true && second_available == false){
                  let formData = { 
                         id: variant_id_str2,
                         quantity: 1,
                      };
                main__this.freeAddToCart(formData);
              }else if(available == false && second_available == true){
                 let formData = { 
                         id: variant_id_str,
                         quantity: 1,
                      };
                main__this.freeAddToCart(formData);
              }
                
            }else if(cart.total_price > free_product_price){
              if(available == false){
                  let formData = {
                    id: variant_id_str,
                    quantity: 1,
                  };
                  main__this.freeAddToCart(formData);
                }
               
            }
          });
      }).catch(function(err) {
        console.error(err)
      });
   }

}
customElements.define('upsell-addtocart', UpsellAddToCart);
